  <div class="title">{{title}}</div>
  <div class="description">{{description}}</div>
  <div class="action">
    <mat-slide-toggle (change)="change()" [(ngModel)]="mail"></mat-slide-toggle>
  </div>
